import makeStyles from '@mui/styles/makeStyles';

const useDropDownStyles = makeStyles({
  root: {}
});

export default useDropDownStyles;
